import { AgencyRoutes } from '../router.types';

export const agencyRoutes: AgencyRoutes = {
  agencySettings: '/agency/settings',
  agencyTalent: '/agency/talent',
  agencyUsage: '/agency/usage',
};
